import React from 'react';
import Box from 'atomic/utilization/box';
import MultiCarousel, { MultiCarouselProductsProps } from 'components/box-product-carousel/components/multi-carousel';
import MultiCarouselPlaceholder from 'components/box-product-carousel/components/multi-carousel-placeholder';

import './box-product-carousel.scss';

interface BoxProductsCarouselProps {
    headerTitle: string;
    products: MultiCarouselProductsProps | null;
    isMobile: boolean;
}

const BoxProductsCarousel: React.FC<BoxProductsCarouselProps> = ({
    headerTitle,
    children,
    products,
    isMobile

}) => (
    <div className="box-products-carousel">
        {headerTitle && (
            <h2 className="box-products-carousel__header">
                {headerTitle}
            </h2>
        )}
        <div className="box-products-carousel__content">
            <Box className="box--mt-0">
                {products === null
                    ? <MultiCarouselPlaceholder itemCount={isMobile ? 2 : 6}/>
                    : <MultiCarousel products={products} itemsOnDesktop={6} itemsOnMobile={1.5}
                        isMobile={isMobile}
                    />}
            </Box>
            <div className="box-products-carousel__content__bottom">
                {children}
            </div>
        </div>
    </div>
);

export default BoxProductsCarousel;
